import React, { useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Input } from 'ncoded-component-library';
import useCallbackRef from 'hooks/useCallbackRef';
import { isEnterPressed, isEscapePressed } from 'utils';

import './RfiInfoNameEdit.styles.scss';

const INPUT_PADDING = 6;

type RfiInfoNameEditProps = {
  className?: string;
  name: string;
  disabled?: boolean;
  onSave: (value: string) => void;
  onClose: () => void;
};

const RfiInfoNameEdit: React.FC<RfiInfoNameEditProps> = (props) => {
  const { className, name, disabled, onSave, onClose } = props;

  const classes = classNames('rfi-info-name-edit', className);

  const [value, setValue] = useState(name);

  const [input, inputRef] = useCallbackRef();
  const [span, spanRef] = useCallbackRef();

  const handleSave = useCallback(() => {
    if (!value || value === name) {
      onClose();
      return;
    }

    onSave(value);
  }, [value, name, onSave, onClose]);

  const onKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (isEnterPressed(e)) handleSave();
      else if (isEscapePressed(e)) onClose();
    },
    [handleSave, onClose],
  );

  useEffect(() => {
    if (span && input)
      input.style.width = `${span.offsetWidth + 2 * INPUT_PADDING}px`;
  }, [input, value, span]);

  useEffect(() => {
    if (input) input.focus();
  }, [input]);

  return (
    <div className={classes}>
      <Input
        value={value}
        autoFocus
        ref={inputRef}
        disabled={disabled}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={onKeyDown}
        onBlur={handleSave}
      />

      <span ref={spanRef} className="rfi-info-name-edit__span">
        {value}
      </span>
    </div>
  );
};

export default RfiInfoNameEdit;
